<template>
  <div class="container">

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item>审批设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>

    <div class="head">
        <img src="@/assets/director/workmaster/clock_in.png"/>
        <div>
            <p class="title">兼职呗审批</p>
            <p class="desc">审批功能可以方便工作的管理，以及更加规范的办公体系，提高效益。 </p>
        </div>
    </div>

    <div class="cont">
      <p style="display: flex;justify-content: space-between;">
        <span style="font-weight:bold;">设置列表</span>
        <span style="font-weight:bold;color:blue; cursor: pointer;" @click="leaveList">审批列表</span>
      </p>
      <div class="clock-list">
          <div class="unit"  v-for="(item, index) in pageProps.records" :key="index">
              <div class="title">{{item.title}}</div>
              <div class="op">
                 <span v-if="item.link==1">请假申请</span> 
                 <span v-if="item.link==2">出差，加班申请</span> 
                 <span v-if="item.link==3">报销审批</span> 
                 <p class="btns"> 
                    <span @click="delLeave(item)" style="cursor: pointer;">删除</span>
                    <span @click="editLeave(item)" style="cursor: pointer;">编辑</span>
                </p>
              </div>
          </div>

      </div>

      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
   
      <p style="font-weight:bold;display: flex;justify-content: space-between;">
        <span>审批设置</span>
       
      </p>
      <div class="edit-list">

        <div class="unit">
            <p class="title">请假设置</p>
            <p class="desc">请假申请设置，点击添加</p>
            <p class="btns"> 
                  <span @click="addLeave(1)" style="cursor: pointer;">添加</span>
              </p>
        </div>

        <div class="unit">
            <p class="title">出差加班</p>
            <p class="desc">出差加班申请设置，点击添加</p>
            <p class="btns"> 
                  <span @click="addLeave(2)" style="cursor: pointer;">添加</span>
              </p>
        </div>

        <div class="unit">
            <p class="title">报销</p>
            <p class="desc">报销申请设置，点击添加</p>
            <p class="btns"> 
                  <span @click="addLeave(3)" style="cursor: pointer;">添加</span>
              </p>
        </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import { leaveEmplaceList ,leaveEmplaceDel} from "@/api/director/workmaster/index";

export default {
    name: "Director-Work-Approval-index",
    data() {
      return {
       
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          name:"",
          page:0,
          limit:0
        }

      }
    },

    mounted() {
      this.fetchData();
    },


    methods: {

      editLeave(item){
        this.$router.push({path:'/director-workmaster-approval-set',query:{link:item.link,job_id:item.job_id}});
      },
      addLeave(type){
        this.$router.push({path:'/director-workmaster-approval-set',query:{link:type}});
      },



      leaveList(){
        this.$router.push({path:'/director-workmaster-approval-list',query:{a:123456}});
        
      },

      delLeave(item){
        var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          leaveEmplaceDel({id:item.id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }
            });
          
        }).catch(() => {
        
        });
      },

      


      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        leaveEmplaceList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin: 0px 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin: 10px 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>